import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isFixedPayment(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.FIXED_PAYMENT && typeof label === 'string' && Array.isArray(value);
}
function _formatFixedPayment(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatFixedPayment(submission) {
  if (isFixedPayment(submission)) {
    return _formatFixedPayment(submission);
  }
  return undefined;
}
//# sourceMappingURL=fixed-payment-preview.js.map